export const CURRENCIES = [
    // North America
    { code: "USD", name: "US Dollar" },
    { code: "CAD", name: "Canadian Dollar" },
    { code: "MXN", name: "Mexican Peso" },

    // South America
    { code: "ARS", name: "Argentine Peso" },
    { code: "BRL", name: "Brazilian Real" },
    { code: "CLP", name: "Chilean Peso" },
    { code: "COP", name: "Colombian Peso" },
    { code: "PEN", name: "Peruvian Sol" },

    // Europe
    { code: "EUR", name: "Euro" },
    { code: "GBP", name: "British Pound" },
    { code: "CHF", name: "Swiss Franc" },
    { code: "NOK", name: "Norwegian Krone" },
    { code: "SEK", name: "Swedish Krona" },
    { code: "DKK", name: "Danish Krone" },
    { code: "PLN", name: "Polish Zloty" },
    { code: "CZK", name: "Czech Koruna" },
    { code: "HUF", name: "Hungarian Forint" },
    { code: "RON", name: "Romanian Leu" },
    { code: "TRY", name: "Turkish Lira" },

    // Middle East
    { code: "ILS", name: "Israeli Shekel" },
    { code: "AED", name: "UAE Dirham" },
    { code: "SAR", name: "Saudi Riyal" },
    { code: "QAR", name: "Qatari Riyal" },
    { code: "EGP", name: "Egyptian Pound" },

    // Asia
    { code: "CNY", name: "Chinese Yuan" },
    { code: "JPY", name: "Japanese Yen" },
    { code: "KRW", name: "South Korean Won" },
    { code: "TWD", name: "New Taiwan Dollar" },
    { code: "HKD", name: "Hong Kong Dollar" },
    { code: "SGD", name: "Singapore Dollar" },
    { code: "THB", name: "Thai Baht" },
    { code: "VND", name: "Vietnamese Dong" },
    { code: "PHP", name: "Philippine Peso" },
    { code: "INR", name: "Indian Rupee" },
    { code: "PKR", name: "Pakistani Rupee" },
    { code: "BDT", name: "Bangladeshi Taka" },
    { code: "LKR", name: "Sri Lankan Rupee" },

    // Oceania
    { code: "AUD", name: "Australian Dollar" },
    { code: "NZD", name: "New Zealand Dollar" },

    // Africa
    { code: "ZAR", name: "South African Rand" },
    { code: "NGN", name: "Nigerian Naira" },
    { code: "KES", name: "Kenyan Shilling" },
];
